var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toolbar',[(_vm.heading)?_c('h2',[_c('i',{staticClass:"fa fa-bell"}),_vm._v(" "+_vm._s(_vm.heading))]):_vm._e(),_vm._t("default"),_c('div',{staticClass:"controls"},[_c('nav-tabs',{attrs:{"tabs":_vm.tabs}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }